export const TIME_TO_REFETCH = 600000;

export const ONLY_NUMBERS_REGEX = /[^\d]/;

export const SERVER_DATE_FORMAT = 'YYYY-MM-DD';

export const DEFAULT_DATE_FORMAT = 'DD-MM-YYYY';
